import { IAdminReferralPartnerSaveDefaultLocaleEnum } from 'api'

export type SiteLocale = IAdminReferralPartnerSaveDefaultLocaleEnum

export const SITE_LOCALE_OPTIONS: { label: string; value: SiteLocale }[] = [
  { label: 'EN — English', value: IAdminReferralPartnerSaveDefaultLocaleEnum.En },
  { label: 'JP — 日本語', value: IAdminReferralPartnerSaveDefaultLocaleEnum.Ja },
  {
    label: 'TW — 繁體中文',
    value: IAdminReferralPartnerSaveDefaultLocaleEnum.ZhTW,
  },
  {
    label: 'CN — 简体中文',
    value: IAdminReferralPartnerSaveDefaultLocaleEnum.ZhCN,
  },
  { label: 'TH — ไทย', value: IAdminReferralPartnerSaveDefaultLocaleEnum.Th },
  { label: 'KR — 한국어', value: IAdminReferralPartnerSaveDefaultLocaleEnum.Ko },
  { label: 'MN — Монгол', value: IAdminReferralPartnerSaveDefaultLocaleEnum.Mn },
  { label: 'RU — Русский', value: IAdminReferralPartnerSaveDefaultLocaleEnum.Ru },
]

export const DEFAULT_SITE_LOCALE = IAdminReferralPartnerSaveDefaultLocaleEnum.En
